import { render, staticRenderFns } from "./SignUpTwo.vue?vue&type=template&id=d4a62cd6&scoped=true&"
import script from "./SignUpTwo.vue?vue&type=script&lang=js&"
export * from "./SignUpTwo.vue?vue&type=script&lang=js&"
import style0 from "./SignUpTwo.vue?vue&type=style&index=0&id=d4a62cd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a62cd6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VBtn,VCardText,VForm,VTextField})
